import React, { useEffect, useRef, useState } from 'react';
import { InfiniteHorizontalSwipeProps } from '../../types/swipeable';

export const InfiniteHorizontalSwipe: React.FC<InfiniteHorizontalSwipeProps> = ({ 
  subPageIds, 
  currentIndex 
}) => {
  const totalPages = subPageIds.length;
  const containerRef = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const prevIndexRef = useRef(currentIndex);
  
  // 無限スクロールのために画像を3セット用意
  const infiniteImages = [
    ...subPageIds,
    ...subPageIds,
    ...subPageIds
  ];

  useEffect(() => {
    const diff = currentIndex - prevIndexRef.current;
    prevIndexRef.current = currentIndex;
    
    // 差分を反映
    setIsTransitioning(true);
    setOffset(prev => prev + diff);
    
    // トランジション後に位置をリセット
    const timer = setTimeout(() => {
      const normalizedIndex = ((currentIndex % totalPages) + totalPages) % totalPages;
      setIsTransitioning(false);
      setOffset(normalizedIndex);
    }, 850); // transitionの0.8sより少し長め
    
    return () => clearTimeout(timer);
  }, [currentIndex, totalPages]);

  return (
    <div className="infinite-horizontal-container" ref={containerRef}>
      <div 
        className="horizontal-pages-container"
        style={{
          transform: `translateX(-${(offset + totalPages) * 100}%)`,
          transition: isTransitioning ? 'transform 0.8s cubic-bezier(0.25, 0.1, 0.25, 1)' : 'none'
        }}
      >
        {infiniteImages.map((imageId, index) => (
          <div
            key={`${imageId}-${index}`}
            className="qwipe-sub-page-image"
            style={{
              backgroundImage: `url(/assets/images/${imageId}.webp)`,
              left: `${index * 100}%`,
            }}
          />
        ))}
      </div>
    </div>
  );
};
